import { Route } from 'vue-router';
import {
  MAIN_ROUTES,
  SUB_ROUTES,
} from '@/router/components';
import { BackgroundColors } from '@/@types/types';

const frontendNext = () => import('@/views/FrontendNextRouteView.vue');

/**
 * Production monitors routes. The list and Sentinel pages are rendered by front-next on `/monitors`.
 */
const monitorsRoutes = {
  path: '/monitors',
  meta: {
    requiresAuth: true,
    breadCrumb: 'app.navigation-drawer.monitors',
  },
  component: MAIN_ROUTES.MONITORS,
  children: [
    {
      path: '',
      name: 'monitors',
      meta: {
        requiresAuth: true,
        hideBreadCrumb: true,
        breadCrumb: 'monitors.breadcrumb.list',
        background: BackgroundColors.SECONDARY,
        negativeMargin: true,
      },
      component: frontendNext,
    },
    {
      path: 'rule/add',
      name: 'monitors.rule.new',
      meta: {
        requiresAuth: true,
        breadCrumb: 'monitors.breadcrumb.add',
        breadCrumbFromParamName: true,
        background: BackgroundColors.SECONDARY,

      },
      props: true,
      component: SUB_ROUTES.RULE_ADD,
    }, {
      path: 'rule/:id',
      redirect: (to: Route) => ({
        name: 'monitors.rule.overview',
        params: to.params,
      }),
    },
    {
      path: 'rule/:id/overview',
      name: 'monitors.rule.overview',
      props: true,
      meta: {
        requiresAuth: true,
        breadCrumbFromParamName: true,
        params: ['id', 'name'],
        hideBreadCrumb: true,
        breadCrumb: 'monitors.breadcrumb.monitor.overview',
        background: BackgroundColors.SECONDARY,
        negativeMargin: true,
      },
      component: frontendNext,
    },
    {
      path: 'rule/:id/runs',
      name: 'monitors.rule.runs',
      props: true,
      meta: {
        requiresAuth: true,
        breadCrumbFromParamName: true,
        params: ['id', 'name'],
        hideBreadCrumb: true,
        breadCrumb: 'monitors.breadcrumb.monitor.runs',
        background: BackgroundColors.SECONDARY,
        negativeMargin: true,
      },
      component: frontendNext,
    },
    {
      path: 'rule/:id/details',
      name: 'monitors.rule.details',
      props: true,
      meta: {
        requiresAuth: true,
        breadCrumbFromParamName: true,
        params: ['id', 'name'],
        hideBreadCrumb: true,
        breadCrumb: 'monitors.breadcrumb.monitor.details',
        background: BackgroundColors.SECONDARY,
        negativeMargin: true,
      },
      component: frontendNext,
    },
    {
      path: 'rule/:id/notifications',
      name: 'monitors.rule.notifications',
      props: true,
      meta: {
        requiresAuth: true,
        breadCrumbFromParamName: true,
        params: ['id', 'name'],
        hideBreadCrumb: true,
        breadCrumb: 'monitors.breadcrumb.monitor.notifications',
        background: BackgroundColors.SECONDARY,
        negativeMargin: true,
      },
      component: frontendNext,
    },
    {
      path: 'rule/:id/edit',
      name: 'monitors.rule.edit',
      meta: {
        requiresAuth: true,
        breadCrumb: 'monitors.breadcrumb.monitor.edit',
        breadCrumbFromParamName: true,
        background: BackgroundColors.SECONDARY,
      },
      props: true,
      component: SUB_ROUTES.RULE_EDIT,
    }, {
      path: 'rule/:id/clone',
      name: 'monitors.rule.clone',
      meta: {
        requiresAuth: true,
        breadCrumb: 'monitors.breadcrumb.monitor.clone',
        breadCrumbFromParamName: true,
        background: BackgroundColors.SECONDARY,

      },
      props: true,
      component: SUB_ROUTES.RULE_EDIT,
    },
    {
      path: 'sentinel/sessions',
      name: 'monitors-sentinel-sessions',
      meta: {
        requiresAuth: true,
        hideBreadCrumb: true,
        breadCrumb: 'monitors.breadcrumb.list',
        background: BackgroundColors.SECONDARY,
        negativeMargin: true,
      },
      component: frontendNext,
    },
    {
      path: 'sentinel/add',
      name: 'monitors-sentinel-add',
      meta: {
        requiresAuth: true,
        hideBreadCrumb: true,
        breadCrumb: 'monitors.breadcrumb.list',
        background: BackgroundColors.SECONDARY,
        negativeMargin: true,
      },
      component: frontendNext,
    },
    {
      path: 'sentinel/sessions/:id',
      name: 'monitors-sentinel-session',
      props: true,
      meta: {
        requiresAuth: true,
        breadCrumbFromParamName: true,
        params: ['id'],
        breadCrumb: 'monitors.breadcrumb.list',
        background: BackgroundColors.SECONDARY,
        negativeMargin: true,
      },
      component: frontendNext,
    },
  ],
};

export default monitorsRoutes;
